// extracted by mini-css-extract-plugin
export default {"page":"AT-z","cartModal":"BT-z","checkout":"CT-z","placeholder":"DT-z","account":"ET-z"};